import { ADMIN_PANEL_BORDER_COLOR, ADMIN_PANEL_HEADER_BACKGROUND_COLOR, BOMBS_PANEL_BACKGROUND_COLOR, BOMBS_PANEL_BORDER_COLOR, CHAT_PANEL_BACKGROUND_COLOR, CHAT_PANEL_BORDER_COLOR, DEBUG_PANEL_BACKGROUND_COLOR, DEBUG_PANEL_BORDER_COLOR, FRIENDS_PANEL_BACKGROUND_COLOR, FRIENDS_PANEL_BORDER_COLOR, HISTORY_PANEL_BACKGROUND_COLOR, HISTORY_PANEL_BORDER_COLOR, PLAYER_INFO_PANEL_BACKGROUND_COLOR, PLAYER_INFO_PANEL_BORDER_COLOR, PRIVATE_MESSAGES_PANEL_BACKGROUND_COLOR, PRIVATE_MESSAGES_PANEL_BORDER_COLOR, ROOM_INFO_PANEL_BACKGROUND_COLOR, ROOM_INFO_PANEL_BORDER_COLOR, SELF_PANEL_BACKGROUND_COLOR, SELF_PANEL_BORDER_COLOR, SIDE_BETS_PANEL_BACKGROUND_COLOR, SIDE_BETS_PANEL_BORDER_COLOR } from '../styles/colors';
// listed in default order they will show up in the UI
export const ALL_PANEL_TYPES = [
    'chat',
    'pokerRoomInfo',
    'players',
    'friends',
    'directMessages',
    'playerInfo',
    'self',
    'tourneyStandings',
    'bombs',
    'sideBets',
    'history',
    'debug',
    'admin'
];
export const ALL_PANEL_PROPERTIES = {
    chat: {
        backgroundColor: CHAT_PANEL_BACKGROUND_COLOR,
        borderColor: CHAT_PANEL_BORDER_COLOR
    },
    pokerRoomInfo: {
        backgroundColor: ROOM_INFO_PANEL_BACKGROUND_COLOR,
        borderColor: ROOM_INFO_PANEL_BORDER_COLOR
    },
    players: {
        backgroundColor: ROOM_INFO_PANEL_BACKGROUND_COLOR,
        borderColor: ROOM_INFO_PANEL_BORDER_COLOR
    },
    friends: {
        backgroundColor: FRIENDS_PANEL_BACKGROUND_COLOR,
        borderColor: FRIENDS_PANEL_BORDER_COLOR
    },
    directMessages: {
        backgroundColor: PRIVATE_MESSAGES_PANEL_BACKGROUND_COLOR,
        borderColor: PRIVATE_MESSAGES_PANEL_BORDER_COLOR
    },
    playerInfo: {
        backgroundColor: PLAYER_INFO_PANEL_BACKGROUND_COLOR,
        borderColor: PLAYER_INFO_PANEL_BORDER_COLOR
    },
    self: {
        backgroundColor: SELF_PANEL_BACKGROUND_COLOR,
        borderColor: SELF_PANEL_BORDER_COLOR
    },
    tourneyStandings: {
        backgroundColor: ROOM_INFO_PANEL_BACKGROUND_COLOR,
        borderColor: ROOM_INFO_PANEL_BORDER_COLOR
    },
    bombs: {
        backgroundColor: BOMBS_PANEL_BACKGROUND_COLOR,
        borderColor: BOMBS_PANEL_BORDER_COLOR
    },
    sideBets: {
        backgroundColor: SIDE_BETS_PANEL_BACKGROUND_COLOR,
        borderColor: SIDE_BETS_PANEL_BORDER_COLOR
    },
    history: {
        backgroundColor: HISTORY_PANEL_BACKGROUND_COLOR,
        borderColor: HISTORY_PANEL_BORDER_COLOR
    },
    debug: {
        backgroundColor: DEBUG_PANEL_BACKGROUND_COLOR,
        borderColor: DEBUG_PANEL_BORDER_COLOR
    },
    admin: {
        backgroundColor: ADMIN_PANEL_HEADER_BACKGROUND_COLOR,
        borderColor: ADMIN_PANEL_BORDER_COLOR
    }
};
